import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <LandingPage data-id="element-0" data-mp="3k89sdu7kovif" />
      <noscript data-id="element-1" data-mp="3k8t7l35u95sr">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3k78dtfrclqvy" />
      </noscript>
    </>;
}